module.exports = __webpack_public_path__ + "static/img/az.451284ce.svg";